import React, { useState } from "react";

const ReadMore = ({ text, limit = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (text.length <= limit) {
    return <span>{text}</span>;
  }

  return (
    <span>
      {isExpanded ? text : text.substring(0, limit) + "... "}
      <p
        onClick={() => setIsExpanded(!isExpanded)}
        className=" mb-0"
      >
        {isExpanded ? "Read Less" : "Read More"}
      </p>
    </span>
  );
};

export default ReadMore;
